import { useId } from "react";

export const GoogleGMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M23.5 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.39 3.62v3h3.87c2.26-2.09 3.57-5.16 3.57-8.81z"/>
    <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.87-3c-1.07.72-2.44 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.29v3.1A12 12 0 0 0 12 24z"/>
    <path fill="#FBBC05" d="M5.27 14.28A7.2 7.2 0 0 1 4.89 12c0-.79.14-1.56.38-2.28v-3.1H1.29a12 12 0 0 0 0 10.76l3.98-3.1z"/>
    <path fill="#EA4335" d="M12 4.76c1.76 0 3.34.6 4.58 1.8l3.44-3.44A11.98 11.98 0 0 0 12 0 12 12 0 0 0 1.29 6.62l3.98 3.1C6.22 6.87 8.87 4.76 12 4.76z"/>
  </svg>
);

export const MicrosoftMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="1" y="1" width="10.5" height="10.5" fill="#F25022" />
    <rect x="12.5" y="1" width="10.5" height="10.5" fill="#7FBA00" />
    <rect x="1" y="12.5" width="10.5" height="10.5" fill="#00A4EF" />
    <rect x="12.5" y="12.5" width="10.5" height="10.5" fill="#FFB900" />
  </svg>
);

export const MicrosoftLogo = () => {
  const gid = useId().replace(/:/g, "");
  return (
    <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#7C2CF3" />
        </linearGradient>
      </defs>
      <rect x="3" y="3" width="26" height="26" rx="8" fill={`url(#${gid})`} />
      <rect x="11" y="11" width="10" height="10" rx="2" fill="#FFFFFF" />
    </svg>
  );
};

export const QuickBooksLogo = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 34 34" aria-hidden="true">
    <circle cx="17" cy="17" r="17" fill="#2CA01C" />
    <text x="17" y="22.5" textAnchor="middle" fontSize="14" fontWeight="700" fill="#FFFFFF" fontFamily="Inter, sans-serif">qb</text>
  </svg>
);

export const DriveLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 30" aria-hidden="true">
    <path d="M12 3 L27 3 L32 12 L17 12 Z" fill="#F4B400" />
    <path d="M17 12 L32 12 L22 28 L7 28 Z" fill="#0F9D58" />
    <path d="M12 3 L17 12 L7 28 L2 19 Z" fill="#4285F4" />
  </svg>
);

export const SlackLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="13" y="2" width="6" height="13" rx="3" fill="#36C5F0" />
    <rect x="7" y="8" width="6" height="6" rx="3" fill="#36C5F0" />
    <rect x="13" y="17" width="6" height="13" rx="3" fill="#2EB67D" />
    <rect x="19" y="18" width="6" height="6" rx="3" fill="#2EB67D" />
    <rect x="2" y="13" width="13" height="6" rx="3" fill="#E01E5A" />
    <rect x="8" y="7" width="6" height="6" rx="3" fill="#E01E5A" />
    <rect x="17" y="13" width="13" height="6" rx="3" fill="#ECB22E" />
    <rect x="18" y="19" width="6" height="6" rx="3" fill="#ECB22E" />
  </svg>
);

export const StripeLogo = ({ width = 58 }) => (
  <svg width={width} height={width * 0.45} viewBox="0 0 58 26" aria-hidden="true">
    <text x="29" y="20" textAnchor="middle" fontSize="21" fontWeight="800" fill="#635BFF" fontFamily="Inter, sans-serif" letterSpacing="-1">stripe</text>
  </svg>
);

export const GmailLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <path d="M5 26h4V13L5 9.5z" fill="#4285F4" />
    <path d="M27 26h-4V13l4-3.5z" fill="#34A853" />
    <path d="M5 9.5V8a3 3 0 0 1 3-3h1.2L16 10z" fill="#EA4335" opacity="0.9" />
    <path d="M27 9.5V8a3 3 0 0 0-3-3h-1.2L16 10z" fill="#FBBC05" />
    <path d="M9 13l7 5.4L23 13l4-3.5L16 15.5 5 9.5z" fill="#EA4335" />
  </svg>
);

export const CalendarLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="3" y="4" width="26" height="25" rx="4" fill="#FFFFFF" stroke="#DADCE0" strokeWidth="1.5" />
    <path d="M3 8a4 4 0 0 1 4-4h9v5H3z" fill="#4285F4" />
    <path d="M16 4h9a4 4 0 0 1 4 4v1H16z" fill="#34A853" />
    <text x="16" y="24" textAnchor="middle" fontSize="13" fontWeight="700" fill="#4285F4" fontFamily="Inter, sans-serif">31</text>
  </svg>
);

export const SalesforceLogo = ({ width = 44 }) => (
  <svg width={width} height={width * 0.73} viewBox="0 0 44 32" aria-hidden="true">
    <path d="M15.5 26a6.5 6.5 0 0 1-.9-12.9A9 9 0 0 1 32 10.5 7.5 7.5 0 0 1 37.5 26z" fill="#00A1E0" />
    <text x="22" y="22.5" textAnchor="middle" fontSize="6.5" fontWeight="600" fill="#FFFFFF" fontFamily="Inter, sans-serif">salesforce</text>
  </svg>
);

const BadgeLogo = ({ bg, letter, rounded = "rounded-lg", size = 34 }) => (
  <span
    className={`${rounded} flex items-center justify-center text-white font-bold select-none shrink-0`}
    style={{ background: bg, width: size, height: size, fontSize: size * 0.45 }}
    aria-hidden="true"
  >
    {letter}
  </span>
);

export const TeamsLogo = () => <BadgeLogo bg="#6264A7" letter="T" />;
export const HubSpotLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="16" r="16" fill="#FF7A59" />
    <circle cx="16" cy="17" r="5" fill="none" stroke="#FFFFFF" strokeWidth="2.4" />
    <path d="M19.5 13.5 L23.5 9.5" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="24.5" cy="8.5" r="3" fill="#FFFFFF" />
  </svg>
);
export const XeroLogo = () => <BadgeLogo bg="#13B5EA" letter="X" rounded="rounded-full" />;
export const SquareLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="3" y="3" width="26" height="26" rx="6" fill="#1A1A1A" />
    <rect x="10" y="10" width="12" height="12" rx="3" fill="none" stroke="#FFFFFF" strokeWidth="2.5" />
  </svg>
);
export const OutlookLogo = () => <BadgeLogo bg="#0F6CBD" letter="O" />;
export const CalendlyLogo = () => <BadgeLogo bg="#006BFF" letter="C" rounded="rounded-2xl" />;
export const OneDriveLogo = () => (
  <svg width="38" height="30" viewBox="0 0 38 30" aria-hidden="true">
    <path d="M11 26a7 7 0 0 1-.6-14A10 10 0 0 1 29 11a7.5 7.5 0 0 1-1 15z" fill="#0078D4" />
  </svg>
);
export const SharePointLogo = () => <BadgeLogo bg="#038387" letter="S" rounded="rounded-full" />;
export const DropboxLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <path d="M9 3 L16 8 L9 13 L2 8 Z" fill="#0061FF" />
    <path d="M23 3 L30 8 L23 13 L16 8 Z" fill="#0061FF" />
    <path d="M9 21 L16 16 L23 21 L16 26 Z" fill="#0061FF" opacity="0.85" />
    <path d="M2 13 L9 17 L16 12 L9 8 Z" fill="#0061FF" opacity="0" />
    <path d="M2 13 L9 18 L16 13 L9 8 Z" fill="#0061FF" opacity="0.7" />
    <path d="M30 13 L23 18 L16 13 L23 8 Z" fill="#0061FF" opacity="0.7" />
  </svg>
);
export const ZendeskLogo = () => <BadgeLogo bg="#03363D" letter="Z" rounded="rounded-full" />;
export const IntercomLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="3" y="3" width="26" height="26" rx="7" fill="#286EFA" />
    <path d="M11 10v6 M21 10v6" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M10.5 19.5 Q16 24 21.5 19.5" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" fill="none" />
  </svg>
);
export const AsanaLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <circle cx="16" cy="9" r="5" fill="#F06A6A" />
    <circle cx="9.5" cy="21" r="5" fill="#F06A6A" />
    <circle cx="22.5" cy="21" r="5" fill="#F06A6A" />
  </svg>
);
export const TrelloLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="3" y="3" width="26" height="26" rx="5" fill="#0079BF" />
    <rect x="8" y="8" width="7" height="14" rx="1.5" fill="#FFFFFF" />
    <rect x="17" y="8" width="7" height="9" rx="1.5" fill="#FFFFFF" />
  </svg>
);
export const NotionLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="4" y="4" width="24" height="24" rx="5" fill="#FFFFFF" stroke="#1A1A1A" strokeWidth="2.5" />
    <text x="16" y="22" textAnchor="middle" fontSize="15" fontWeight="800" fill="#1A1A1A" fontFamily="Georgia, serif">N</text>
  </svg>
);
export const JiraLogo = () => (
  <svg width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
    <path d="M16 4 L28 16 L16 28 L4 16 Z" fill="#2684FF" />
    <circle cx="16" cy="16" r="3.5" fill="#FFFFFF" />
  </svg>
);
export const GitHubLogo = () => (
  <span className="w-[34px] h-[34px] rounded-full bg-[#24292F] flex items-center justify-center shrink-0" aria-hidden="true">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#FFFFFF">
      <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.55 0-.27-.01-1.17-.02-2.12-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.03 1.76 2.7 1.25 3.36.96.1-.75.4-1.25.72-1.54-2.55-.29-5.24-1.28-5.24-5.68 0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.05 0 0 .97-.31 3.17 1.18a11.1 11.1 0 0 1 5.78 0c2.2-1.49 3.17-1.18 3.17-1.18.62 1.59.23 2.76.11 3.05.74.81 1.18 1.83 1.18 3.09 0 4.42-2.7 5.39-5.26 5.67.41.36.78 1.06.78 2.14 0 1.55-.01 2.79-.01 3.17 0 .31.21.67.8.55A11.52 11.52 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5z"/>
    </svg>
  </span>
);
